import React, { useCallback, useRef } from "react";
import { connect } from "react-redux";
import FormField from '../../../../dynamicFormBuilder/FormField'
import { ConsigneeWMDefaultLayout } from "../../../common/Layouts";

function WMDefaultTab(props) {
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    var currentUser = props.oidc.user;
    const formRefs = useRef({});
    const handleCodesFormLoad = useCallback(() => {
    }, []);
    const handleFieldChange = useCallback((name, value, e) => {
    }, []);



    return (
        <div className="FormMt">
            <FormField
                currrentUser={currentUser}
                layoutId='C0D0A4FA-A148-4D1F-9204-CA6FAFF39D7E'
                layoutName='WMDefaultTab'
                defaultFormSchema={ConsigneeWMDefaultLayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={handleFieldChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={formRefs}
                onFormLoad={handleCodesFormLoad}
            />
        </div>


    );
}

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(WMDefaultTab);
